import { render, staticRenderFns } from "./AuthSupport.vue?vue&type=template&id=0257ba56&scoped=true"
import script from "./AuthSupport.vue?vue&type=script&lang=js"
export * from "./AuthSupport.vue?vue&type=script&lang=js"
import style0 from "./AuthSupport.vue?vue&type=style&index=0&id=0257ba56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0257ba56",
  null
  
)

export default component.exports